import { createTrainingPDF, type TrainingClientParams } from '@gng-ehs/shared';
export { formatDurationDays, type TrainingClientParams } from '@gng-ehs/shared';

export function generateTrainingClientPDF(data: TrainingClientParams): string {
  return URL.createObjectURL(createTrainingPDF(data).output('blob'));
}
